<template>
  <div>
    <div class="filter-inline-panel cle">
      <el-form :inline="true" size="mini" :model="filters" class="filter-panel"></el-form>
      <div class="list-opinion fr">
        <el-button type="primary" size="mini" @click="$router.back(-1)">{{$t('index.return')}}</el-button>
        <el-button type="primary" size="mini" @click="add()" v-if="hasBtn('btn_add')">{{$t('index.add')}}</el-button>
      </div>
    </div>
    <el-table :data="list" border size="mini">
      <el-table-column prop="teacher_id" align="center" label="老师名称" :formatter="teacher_id_f"></el-table-column>
      <el-table-column prop="class_date_time" align="center" label="上课日期" :formatter="session_f"></el-table-column>
      <el-table-column prop="start_time" align="center" label="开始时间" :formatter="session_f"></el-table-column>
      <el-table-column prop="end_time" align="center" label="结束时间" :formatter="session_f"></el-table-column>
      <el-table-column prop="number" align="center" label="第几节课"></el-table-column>
      <el-table-column prop="status" align="center" label="状态" :formatter="status_f"></el-table-column>
      <el-table-column :label="$t('index.operation')" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
          <el-button size="mini" type="danger" @click="del(scope.row)">{{$t('index.del')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-pagination">
      <el-pagination  align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
    </div>
    <el-dialog :title="$t('index.dialog_title')" width="700px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
      <el-row class="tree-content" :gutter="20">
        <el-form :model="editForm" size="mini" label-width="55px" label-position="top" :rules="editFormRules" ref="editForm">
          <el-col :span="12">
            <el-form-item label="老师" prop="teacher_id">
              <el-select v-model="editForm.teacher_id" class="w100" placeholder="请选择">
                <el-option v-for="(item,index) in teacherListNopage" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="String(item.teacher_id)"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上课日期" prop="class_date_time">
            	<el-date-picker v-model="editForm.class_date_time" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="时间" prop="time">
              <el-time-picker v-model="editForm.time" @change="time_f" value-format="timestamp" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" is-range></el-time-picker>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
	data() {
		return {
			id:'',
			list: [],
			editFormVisible: false,
			editForm: {
				
			},
			editFormRules: {
				name_cn: [{
					required: true,
					message: '请输入中文名称',
					trigger: 'blur'
				}],
				name: [{
					required: true,
					message: '请输入英文名称',
					trigger: 'blur'
				}],
				code: [{
					required: true,
					message: '请输入字典编码',
					trigger: 'blur'
				}],
			},
			filters: {},

			pages: {
				page: 1,
				count: 100,
				perpage: 20,
			},
			teacherListNopage:[],
			COURSE_STATUS:[],
		}
	},
	computed:{
		today_start_time:function(){
			var nian=this.getTime('','y');
			return Math.round(new Date(nian.split('-')[0],nian.split('-')[1]-1,nian.split('-')[2],'00','00','00').getTime()/1000);
		},
		today_end_time:function(){
			var nian=this.getTime('','y');
			return Math.round(new Date(nian.split('-')[0],nian.split('-')[1]-1,nian.split('-')[2],'23','59','59').getTime()/1000);
		},
	},
	// 初始事件
	mounted: function () {
		this.id=this.$route.query.id;
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config(){
			var this_ = this;
			var url = "teacherListNopage";
			this_.$post(url, {}).then((res) => {
				this_.teacherListNopage = res;
			})
			var url = "getDictionaryValue";
			var datas={
				code:'COURSE_STATUS',
			}
			this_.$post(url,datas).then((res) => {
				this_.COURSE_STATUS = res.COURSE_STATUS;
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "courseTrip";
			var datas = {
				course_id:this_.id,
				page:this_.pages.page,
				num:this_.pages.perpage,
				today_start_time:this_.today_start_time,
				today_end_time:this_.today_end_time,
			};
			this_.$post(url, datas).then((res) => {
				var list = res.list;
				list.forEach(function (e, i) {
					e['class_date_time'] = e.class_date_time * 1000;
					e['start_time'] = e.start_time * 1000;
					e['end_time'] = e.end_time * 1000;
				});
				this_.list = list;
				this_.pages.count = res.num;
			})
		},
		add(data) {
			if (data) {
				var data_data=JSON.parse(JSON.stringify(data));
				var editForm=data_data;
				var time = [];
				time[0] = data_data.start_time?data_data.start_time:new Date;
				time[1] = data_data.end_time?data_data.end_time:new Date;
				editForm['time'] = time;
				this.editForm=editForm;
			} else {
				this.editForm = {
					teacher_id:'',
					class_date_time:'',
					start_time:'',
					end_time:'',
					time:[new Date,new Date],
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},

		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						teacher_id: this_.editForm.teacher_id,
						class_date_time: this_.editForm.class_date_time ? this_.editForm.class_date_time / 1000 : '',
						start_time: this_.editForm.start_time ? this_.editForm.start_time / 1000 : '',
						end_time: this_.editForm.end_time ? this_.editForm.end_time / 1000 : '',
						course_id: this_.id,
					}
					var url = "courseTripAction";
					var tishi = '添加成功';
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = '修改成功';
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		time_f(data) {
			if (data) {
				this.editForm.start_time = data[0];
				this.editForm.end_time = data[1];
			} else {
				this.editForm.start_time = '';
				this.editForm.end_time = '';
			}
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "courseTripDelete";
			var datas = {
				course_id:this_.id,
				id: data.id
			};
			this_.$confirm('确认删除吗?', '提示').then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success('删除成功');
					this_.init();
				})
			});
		},
		teacher_id_f(w,s,d){
			var this_ = this;
			var list=this_.teacherListNopage;
			var name=[];
			var ids=d.split(',');
			var jj=0;
			list.forEach(function(e,i) {
				ids.forEach(function(n,i) {
					if (n==e.teacher_id) {
						name[jj]=this_.lang=='cn'?e.name_cn:e.name;
					}
				});
			});
			return name.join(',');
		},
		status_f(w,s,d){
			var this_ = this;
			var list=this_.COURSE_STATUS;
			var name='';
			list.forEach(function(e,i) {
				if (e.code==d) {
					name=this_.lang=='cn'?e.name_cn:e.name;
				}
			});
			return name;
		},
		session_f(w, s, d) {
			var this_=this;
			var name = s.property;
			if (name == 'class_date_time') {
				var fanhuizhi=new Intl.DateTimeFormat('en-US').format(d);
				if (this.lang=='cn') {
					fanhuizhi=this_.getTime(d/1000, 'y');
				}
				return fanhuizhi;
			} else if (name == 'start_time' || name == 'end_time') {
				var fanhuizhi=this_.getTime(d/1000, 'hi');
				if (this.lang=='cn') {
					fanhuizhi=this_.getTime(d/1000, 'hi');
				}
				return fanhuizhi;
			}
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 22px;
}
.page-pagination {
	padding: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/course_arrange.vue